import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Input,
  Label,
  Form,
  Alert,
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import profile from "assets/images/login_img2.png"
import { app_url } from "app_config"
import { axiosbaseurl } from "configure"

const ForgetPasswordPage = props => {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState({})
  const [loading, setLoading] = useState(false)
  const navigateTo = useNavigate()

  //meta title
  document.title = "Forget Password | Peacock Accountants Limited"

  const handleResetPassword = async e => {
    e.preventDefault()
    try {
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        setMessage({ type: 0, msg: "Valid email is required." })
      } else {
        setLoading(true)

        const { data } = await axiosbaseurl.post("/auth/forgot-password", {
          email,
        })

        if (data.success) {
          setEmail("")
          swal("Password reset successfully! Please check your email.", {
            icon: "success",
          })
          navigateTo(`${app_url}login`)
        } else setMessage({ type: 0, msg: data.message })
      }
    } catch (error) {
      console.log(error)
      setMessage({
        type: 0,
        msg:
          error.response.data.message ||
          error.message ||
          "Something went wrong!",
      })
    } finally {
      setTimeout(() => setMessage({}), 5000)
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={8}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Forgot Password!</h5>
                        <p> Peacock Accountants Limited.</p>
                      </div>
                    </Col>
                    <Col className="col-4 align-self-center pe-4">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-4">
                  <div className="p-2">
                    {message?.type === 0 ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {message.msg}
                      </Alert>
                    ) : null}

                    {message?.type === 1 ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {message.msg}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={handleResetPassword}
                    >
                      <div className="mb-3">
                        <Label className="form-label">
                          Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3 mt-4">
                        <button
                          className="btn btn-primary btn-block w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <i className="bx bx-hourglass bx-spin align-middle me-2"></i>{" "}
                              Sending password on email...
                            </>
                          ) : (
                            "Reset Password"
                          )}
                        </button>
                      </div>
                    </Form>
                  </div>

                  <div className="mt-2 text-center">
                    <p>
                      <i className="fa fa-arrow-left me-3" /> Go back to{" "}
                      <Link
                        to={`${app_url}login`}
                        className="fw-bold text-primary"
                      >
                        Login
                      </Link>{" "}
                    </p>

                    <div className="mt-4 text-center">
                      <p className="px-md-4">
                        Copyright © {new Date().getFullYear()}{" "}
                        <a
                          href="https://www.peacockac.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Peacock Accountants Limited.
                        </a>{" "}
                        <br /> Crafted with{" "}
                        <i className="mdi mdi-heart text-danger" /> by{" "}
                        {
                          process.env.REACT_APP_API_URL?.includes("apibms.peacockac.com") ?
                            <a
                              href="https://www.tcwitservices.com"
                              target="_blank"
                              rel="noreferrer"
                              className="text-dark"
                            >
                              The Care Workshop
                            </a>
                            :
                            <a
                              href="https://zithas.co.uk/"
                              target="_blank"
                              rel="noreferrer"
                              className="text-dark"
                            >
                              Zithas Technologies
                            </a>
                        }
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
